import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class FiltersService {
  async getDefaultFilters(locale) {
    return await axios
      .get(API_URL + `/Tags/tags`, {
        params: {
          culture: locale !== undefined ? locale : "",
        },
      })
      .then((response) => {
        locale == "nl"
          ? store.commit("advancedSearch/updateOndernemerTagName", "Ondernemer")
          : store.commit(
              "advancedSearch/updateOndernemerTagName",
              "Privater Sektor"
            );
        store.commit("advancedSearch/updateFilterActivities", response.data);
        store.commit("advancedSearch/createLocationsOptions");
        store.commit("grantItems/disableSideBarLoading");
        store.commit("news/disableIsNewsSideBarLoading");
        store.commit("portalsData/updateIsPortalsSideBarLoading", false);
      });
  }

  async getApplicationTerms() {
    return await axios
      .get(API_URL + `/Tags/getAllTermsPairs`)
      .then((response) => {
        store.commit("advancedFilters/updateTerms", response.data);
      });
  }

  async searchLocationCodesBulk(query) {
    return await axios
      .get(API_URL + `/tags/searchGermanLocationTagsBulk`, {
        params: {
          query: query,
        },
      })
      .then((response) => {
        store.commit("advancedSearch/setLocationsOptions", response.data);
      });
  }

  getScopes() {
    return axios
      .get(API_URL + "/scheme/getScopes")
      .then((response) => {
        if (response && response.status === 200)
          store.commit("advancedFilters/updateScopeOptions", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }
}

export default new FiltersService();
